/**
 * Pure viewing-decision for chat-presence reporting — extracted so it can be
 * unit-tested without React/Next. See docs/chat-presence-push-suppression.md §3.3.
 */

/** No user activity for this long ⇒ treat a focused-but-abandoned tab as not viewing. */
export const ACTIVITY_IDLE_MS = 3 * 60_000;
/** Keep-alive cadence while viewing — refreshes the server-side presence TTL (~60s). */
export const KEEP_ALIVE_MS = 25_000;

export interface PresenceInputs {
  /** A chat surface is open on the active conversation (useChatOverlayOpen, both brands). */
  overlayOpen: boolean;
  /** The conversation currently on screen, or null. */
  conversationId: string | null;
  /** document.visibilityState === 'visible'. */
  visible: boolean;
  /** Timestamp (ms) of the last pointer/keydown/scroll activity. */
  lastActivityMs: number;
  /** "now" in ms. */
  now: number;
}

/**
 * True only when a chat surface is open on a real conversation, the tab is
 * visible, and the user was active within {@link ACTIVITY_IDLE_MS}. Any
 * condition false ⇒ not viewing.
 */
export function shouldReport(i: PresenceInputs): boolean {
  return (
    i.overlayOpen &&
    !!i.conversationId &&
    i.visible &&
    i.now - i.lastActivityMs <= ACTIVITY_IDLE_MS
  );
}
